import { useLocation } from 'react-router-dom';
import axios from 'axios';
import AuthFacade from '../redux/auth/Auth.facade';
import { USER_TYPE } from '../constants';
import useAuthExternalUser from './useAuthExternalUser';
import { findReverseProxyURL } from '../constants/config';
import { useRef } from 'react';
const useAuthorization = () => {
  const location = useLocation();
  const isFetching = useRef(false);
  const fetchTokenAndUserData = async () => {
    if (!isFetching.current) {
      isFetching.current = true;
      const { setAuthorizationData, setHideSidebar } = AuthFacade();
      const { externalUserLogout, externalUserDetails } = useAuthExternalUser();
      const isExternalWithReverseProxy = findReverseProxyURL();
      let url;
      if (isExternalWithReverseProxy) {
        url = '/' + isExternalWithReverseProxy + '/api/getToken';
      } else {
        url = '/api/getToken';
      }
      // Get the authorization code from the URL
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      try {
        const response = await axios.post(
          url,
          { code: code },
          {
            headers: {
              'Content-Type': 'application/json', // necessary for expressjs
              'Access-Control-Allow-Origin': '*',
            },
          }
        );

        if (response.data) {
          sessionStorage.setItem(
            'externalUserData',
            JSON.stringify(response.data)
          );
          sessionStorage.setItem('userType', USER_TYPE.externalUser);
          sessionStorage.setItem('userActivity', false);
          setAuthorizationData(response.data);
          setHideSidebar(true);
        }
      } catch (error) {
        console.error('Failed to get token error:', error);
        let externalUserData = externalUserDetails();
        if (externalUserData?.accessToken?.access_token === undefined) {
          externalUserLogout();
        } else {
          setHideSidebar(true);
        }
      } finally {
        isFetching.current = false;
      }
    }
  };

  return {
    fetchTokenAndUserData,
  };
};

export default useAuthorization;
